type LogoutOptions = {
  getIdToken: () => Promise<string | undefined>;
  signOut: () => Promise<void>;
  logoutUrl: string;
  baseUrl: string;
  redirect: (url: string) => void;
};

export async function signOutWithKeycloak(options: LogoutOptions) {
  // Capture the optional hint before clearing the portal's provider session.
  const idToken = await options.getIdToken().catch(() => undefined);
  await options.signOut();
  const url = new URL(options.logoutUrl);
  url.searchParams.set('client_id', 'backstage');
  url.searchParams.set('post_logout_redirect_uri', options.baseUrl);
  if (idToken) url.searchParams.set('id_token_hint', idToken);
  options.redirect(url.toString());
}
